import { api } from './http'

export function getAdminUsers(page = 1, size = 10, keyword = '') {
  return api.get('/admin/users', { params: { page, size, keyword } })
}

export function updateUser(id, userData) {
  return api.put(`/admin/users/${id}`, userData)
}

export function deleteUser(id) {
  return api.delete(`/admin/users/${id}`)
}

export { api }
